// messagesCache.ts
import { QueryClient } from '@tanstack/react-query'
import { ConversationsData, Quote } from '@/data/PetSitter/Messages'

export const conversationsKey = ['conversationsData']

export function updateConversationsListFromMercure(queryClient: QueryClient, data: any) {
  if (!data || !data['@conversation']) return

  queryClient.setQueriesData({ queryKey: conversationsKey }, (old: any) => {
    if (!old?.pages) return old

    const pages = old.pages.map((page: ConversationsData) => {
      const list = [...(page?.['hydra:member'] ?? [])]
      const idx = list.findIndex((c) => c['@conversation'] === data['@conversation'])
      if (idx !== -1) {
        list[idx] = { ...list[idx], ...data }
        return { ...page, 'hydra:member': list }
      }
      return page
    })

    const found = pages.some((p: ConversationsData) =>
      (p?.['hydra:member'] ?? []).some((c: any) => c['@conversation'] === data['@conversation']),
    )

    if (!found && pages.length > 0) {
      pages[0] = { ...pages[0], 'hydra:member': [data, ...(pages[0]['hydra:member'] ?? [])] }
    }

    return { ...old, pages }
  })
}

export function updateQuoteFromMercure(queryClient: QueryClient, data: Quote) {
  queryClient.setQueryData([`quote${data.id}`], data)
}

/**
 * Injecte un nouveau message live dans la query ['conversation', conversationId]
 */
export function appendLiveMessageToConversation(
  queryClient: QueryClient,
  conversationId: string,
  formattedMessage: any,
  rawData: any,
) {
  queryClient.setQueryData(['conversation', conversationId], (old: any) => {
    if (!old?.pages) return old

    const pages = [...old.pages]
    if (pages.length === 0) return old

    const firstIndex = 0
    const firstPage = pages[firstIndex]
    const list = [...(firstPage?.conversationItems?.['hydra:member'] ?? [])]

    const alreadyExists = list.some(
      (m: any) =>
        (m.uuid && m.uuid === rawData.uuid) ||
        (m.id && m.id === rawData.id) ||
        (m['@react'] && rawData['@react'] && m['@react'] === rawData['@react']),
    )

    if (alreadyExists) return old

    const updated = [formattedMessage, ...list]

    pages[firstIndex] = {
      ...firstPage,
      conversationItems: {
        ...firstPage.conversationItems,
        'hydra:member': updated,
      },
    }

    return { ...old, pages }
  })
}
